import { render, staticRenderFns } from "./WorkerTable.vue?vue&type=template&id=b8afe362&"
import script from "./WorkerTable.vue?vue&type=script&lang=js&"
export * from "./WorkerTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports